<div class="ia-config-page" *ngIf="podeConfigurar; else semPermissao">
  <div class="ia-config-hero">
    <div>
      <span class="ia-config-kicker">IA Comercial</span>
      <h1>IA (Config)</h1>
      <p>Configure o provedor, token, prompt e comportamento usado nas consultas comerciais.</p>
    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="carregar()" [disabled]="carregando">Atualizar</button>
  </div>

  <div class="ia-config-card" *ngIf="!carregando">
    <div class="ia-config-grid">
      <label>
        IA ativa
        <select class="form-control" [(ngModel)]="configuracao.ia_ativa">
          <option [ngValue]="true">Sim</option>
          <option [ngValue]="false">Nao</option>
        </select>
      </label>
      <label>
        Provider
        <input class="form-control" [(ngModel)]="configuracao.provider" placeholder="OPENAI" />
      </label>
      <label>
        Modelo IA
        <input class="form-control" [(ngModel)]="configuracao.modelo_ia" placeholder="gpt-4.1-mini" />
      </label>
      <label>
        Temperatura
        <input class="form-control" type="number" min="0" max="2" step="0.01" [(ngModel)]="configuracao.temperatura" />
      </label>
      <label>
        Max tokens
        <input class="form-control" type="number" min="1" [(ngModel)]="configuracao.max_tokens" />
      </label>
      <label>
        Token / API Key
        <input class="form-control" type="password" [(ngModel)]="configuracao.api_key" placeholder="Deixe vazio para manter o token atual" />
      </label>
      <label>
        Chat geral
        <select class="form-control" [(ngModel)]="configuracao.permitir_chat_geral">
          <option [ngValue]="true">Permitido</option>
          <option [ngValue]="false">Bloqueado</option>
        </select>
      </label>
      <label>
        Sugestao de produtos
        <select class="form-control" [(ngModel)]="configuracao.permitir_sugestao_produto">
          <option [ngValue]="true">Permitida</option>
          <option [ngValue]="false">Bloqueada</option>
        </select>
      </label>
    </div>

    <label class="mt-3 w-100">
      Prompt do sistema
      <textarea class="form-control ia-textarea" rows="6" [(ngModel)]="configuracao.prompt_sistema"></textarea>
    </label>

    <label class="mt-3 w-100">
      Prompt comercial complementar
      <textarea class="form-control ia-textarea" rows="5" [(ngModel)]="configuracao.prompt_comercial" placeholder="Regras comerciais adicionais, tom de resposta, limites e excecoes."></textarea>
    </label>

    <label class="mt-3 w-100">
      Script IA - Chat geral
      <textarea class="form-control ia-textarea" rows="6" [(ngModel)]="configuracao.prompt_chat_geral" placeholder="Usado quando o vendedor digita uma pergunta livre. Nao recebe historico de compra nem produtos do segmento."></textarea>
    </label>

    <label class="mt-3 w-100">
      Script IA - Sugestao de produtos
      <textarea class="form-control ia-textarea" rows="7" [(ngModel)]="configuracao.prompt_sugestao_produtos" placeholder="Usado quando o vendedor clica em sugerir produtos do segmento. Recebe historico, produtos, precos e condicoes especiais."></textarea>
    </label>

    <!-- Agente IA - WhatsApp -->

    <div class="ia-whats-section mt-4">
      <div class="ia-whats-header">
        <h2>Agente IA - WhatsApp</h2>
        <p>Atendente virtual que responde as conversas do WhatsApp com base na base de conhecimento abaixo.</p>
      </div>

      <div class="ia-config-grid">
        <label>
          Agente WhatsApp
          <select class="form-control" [(ngModel)]="configuracao.permitir_whatsapp">
            <option [ngValue]="true">Ativado</option>
            <option [ngValue]="false">Desativado</option>
          </select>
        </label>
        <label>
          Modo de operacao
          <select class="form-control" [(ngModel)]="configuracao.whatsapp_modo">
            <option value="AUTO">Automatico (responde sozinha)</option>
            <option value="APROVACAO">Por aprovacao (sugere e o atendente aprova)</option>
            <option value="DESATIVADO">Desativado</option>
          </select>
        </label>
        <label>
          Nome do agente
          <input class="form-control" [(ngModel)]="configuracao.whatsapp_nome_agente" placeholder="Ex.: Lia" />
        </label>
        <label>
          Fora do horario comercial responde automatico
          <select class="form-control" [(ngModel)]="configuracao.whatsapp_fora_horario_auto">
            <option [ngValue]="true">Sim</option>
            <option [ngValue]="false">Nao</option>
          </select>
        </label>
        <label>
          Usa emojis
          <select class="form-control" [(ngModel)]="configuracao.whatsapp_usa_emojis">
            <option [ngValue]="true">Sim, com moderacao</option>
            <option [ngValue]="false">Nao</option>
          </select>
        </label>
        <label>
          Se identifica como IA
          <select class="form-control" [(ngModel)]="configuracao.whatsapp_se_identifica_ia">
            <option [ngValue]="true">Sim (recomendado)</option>
            <option [ngValue]="false">Nao</option>
          </select>
        </label>
        <label>
          Silencio apos resposta humana (min)
          <input class="form-control" type="number" min="0" [(ngModel)]="configuracao.whatsapp_silencio_humano_min" />
        </label>
        <label>
          Mensagens de contexto por conversa
          <input class="form-control" type="number" min="1" max="30" [(ngModel)]="configuracao.whatsapp_contexto_mensagens" />
        </label>
      </div>

      <!-- Horario comercial -->

      <div class="ia-whats-kb mt-3">
        <div class="ia-whats-kb-header">
          <h3>Horario comercial</h3>
        </div>
        <p class="ia-whats-kb-desc">Usado pela opcao "Fora do horario comercial responde automatico": fora desta janela, o modo Aprovacao vira Automatico (nao ha atendente para aprovar). Sem horario cadastrado, considera sempre horario comercial.</p>

        <div class="ia-config-grid">
          <label>
            Inicio
            <input class="form-control" type="time" [(ngModel)]="configuracao.whatsapp_horario_inicio" />
          </label>
          <label>
            Fim
            <input class="form-control" type="time" [(ngModel)]="configuracao.whatsapp_horario_fim" />
          </label>
          <div class="ia-dias-semana">
            <span class="ia-dias-semana-label">Dias de atendimento humano</span>
            <div class="ia-dias-semana-botoes">
              <button type="button" *ngFor="let dia of diasSemana" class="ia-dia-btn" [class.ia-dia-btn-ativo]="isDiaAtivo(dia.valor)" (click)="alternarDia(dia.valor)">{{ dia.rotulo }}</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Regras de transferencia para humano -->

      <div class="ia-whats-kb mt-3">
        <div class="ia-whats-kb-header">
          <h3>Quando transferir para humano</h3>
        </div>
        <p class="ia-whats-kb-desc">Quando qualquer regra disparar, a IA envia a mensagem de transferencia (modo Automatico), pausa nesta conversa (modo IA Off) e avisa o time em tempo real.</p>

        <div class="ia-config-grid">
          <label>
            Contato pede para falar com atendente
            <select class="form-control" [(ngModel)]="configuracao.whatsapp_handoff_pedido_humano">
              <option [ngValue]="true">Transferir</option>
              <option [ngValue]="false">Ignorar</option>
            </select>
          </label>
          <label>
            Irritacao ou reclamacao detectada
            <select class="form-control" [(ngModel)]="configuracao.whatsapp_handoff_sentimento">
              <option [ngValue]="true">Transferir</option>
              <option [ngValue]="false">Ignorar</option>
            </select>
          </label>
          <label>
            Pergunta fora da base de conhecimento
            <select class="form-control" [(ngModel)]="configuracao.whatsapp_handoff_fora_base">
              <option [ngValue]="true">Transferir</option>
              <option [ngValue]="false">Ignorar</option>
            </select>
          </label>
          <label>
            Pedido de desconto / negociacao de valores
            <select class="form-control" [(ngModel)]="configuracao.whatsapp_handoff_negociacao">
              <option [ngValue]="true">Transferir</option>
              <option [ngValue]="false">Ignorar</option>
            </select>
          </label>
        </div>
      </div>

      <label class="mt-3 w-100">
        Mensagem de transferencia para humano
        <input class="form-control" [(ngModel)]="configuracao.whatsapp_msg_handoff" placeholder="Ex.: Vou te passar para um colega do nosso time que ja continua com voce por aqui!" />
      </label>

      <label class="mt-3 w-100">
        Script IA - Atendimento WhatsApp (persona)
        <textarea class="form-control ia-textarea" rows="7" [(ngModel)]="configuracao.prompt_whatsapp_atendimento" placeholder="Personalidade, tom de voz e regras do atendente virtual no WhatsApp."></textarea>
      </label>

      <!-- Base de conhecimento -->

      <div class="ia-whats-kb mt-4">
        <div class="ia-whats-kb-header">
          <h3>Base de conhecimento</h3>
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="novoConhecimento()" [disabled]="conhecimentoEdicao != null">Adicionar conhecimento</button>
        </div>
        <p class="ia-whats-kb-desc">E daqui que o agente tira as respostas (horarios, precos, endereco, politicas). Nao cadastre dados sensiveis.</p>

        <div class="ia-whats-kb-item" *ngFor="let conhecimento of conhecimentos">
          <div class="ia-whats-kb-item-text">
            <b>
              {{ conhecimento.nome }}
              <span class="badge badge-pill ia-kb-tipo-badge" [ngClass]="conhecimento.tipo == 'CONHECIMENTO_PROPRIO' ? 'ia-kb-tipo-proprio' : 'ia-kb-tipo-fixo'">{{ conhecimento.tipo == 'CONHECIMENTO_PROPRIO' ? 'Conhecimento proprio' : 'Conteudo fixo' }}</span>
              <span class="badge badge-pill ia-escopo-badge" [ngClass]="conhecimento.seller_id ? 'ia-escopo-unidade' : 'ia-escopo-geral'">{{ getEscopoNome(conhecimento) }}</span>
            </b>
            <small *ngIf="conhecimento.tipo != 'CONHECIMENTO_PROPRIO'">{{ conhecimento.prompt }}</small>
            <small *ngIf="conhecimento.tipo == 'CONHECIMENTO_PROPRIO'">{{ conhecimento.script_orientacao || 'Sem orientacao especifica - a IA usa apenas a persona.' }}</small>
            <span class="ia-kb-arquivo-chip" *ngIf="conhecimento.arquivo_nome">
              <i class="fa" [ngClass]="conhecimentoTemImagem(conhecimento) ? 'fa-image' : 'fa-paperclip'"></i> {{ conhecimento.arquivo_nome }}
            </span>
            <span class="ia-kb-arquivo-chip" *ngIf="conhecimento.link_url">
              <i class="fa fa-link"></i> {{ conhecimento.link_titulo || conhecimento.link_url }}
            </span>
          </div>
          <div class="ia-whats-kb-item-actions">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="editarConhecimento(conhecimento)">Editar</button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removerConhecimento(conhecimento)">Remover</button>
          </div>
        </div>

        <div class="ia-whats-kb-vazio" *ngIf="conhecimentos.length == 0 && conhecimentoEdicao == null">
          Nenhum conhecimento cadastrado. O agente so respondera com seguranca depois que a base for preenchida.
        </div>

        <div class="ia-whats-kb-editor" #conhecimentoEditor *ngIf="conhecimentoEdicao != null">
          <label class="w-100">
            Nome
            <input class="form-control" [(ngModel)]="conhecimentoEdicao.nome" placeholder="Ex.: Horarios de funcionamento" />
          </label>

          <label class="w-100 mt-2">
            Aplicar para
            <select class="form-control" [(ngModel)]="conhecimentoEdicao.seller_id">
              <option [ngValue]="null">Todas as unidades</option>
              <option *ngFor="let vendedor of vendedores" [ngValue]="vendedor.id">{{ vendedor.fullname }}</option>
            </select>
          </label>

          <label class="w-100 mt-2">
            Tipo de resposta
            <select class="form-control" [(ngModel)]="conhecimentoEdicao.tipo">
              <option value="CONTEUDO">Conteudo fixo (a IA responde exatamente com o texto abaixo)</option>
              <option value="CONHECIMENTO_PROPRIO">Conhecimento proprio (a IA responde com conhecimento geral, so para este topico)</option>
            </select>
          </label>

          <label class="w-100 mt-2" *ngIf="conhecimentoEdicao.tipo == 'CONTEUDO'">
            Conteudo
            <textarea class="form-control ia-textarea" rows="4" [(ngModel)]="conhecimentoEdicao.prompt" placeholder="Ex.: Funcionamos de segunda a sexta das 6h as 23h..."></textarea>
          </label>

          <ng-container *ngIf="conhecimentoEdicao.tipo == 'CONHECIMENTO_PROPRIO'">
            <label class="w-100 mt-2">
              Orientacao para a IA (opcional)
              <textarea class="form-control ia-textarea" rows="4" [(ngModel)]="conhecimentoEdicao.script_orientacao" placeholder="Ex.: Sugira treinos basicos por grupo muscular, sem indicar carga especifica..."></textarea>
            </label>
            <p class="ia-whats-kb-desc">
              Deixando em branco, a IA usa apenas a persona (Script IA - Atendimento WhatsApp) para responder este topico.
              Preenchendo, a IA segue esta orientacao e o sistema acrescenta automaticamente um aviso de seguranca (generalizar, nao garantir resultado, recomendar validar com a equipe).
            </p>
          </ng-container>

          <div class="ia-kb-arquivo mt-2">
            <input #imagemConhecimento type="file" hidden accept="image/jpeg,image/png" (change)="selecionarArquivoConhecimento($event, true)" />
            <input #arquivoConhecimento type="file" hidden accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png" (change)="selecionarArquivoConhecimento($event)" />

            <ng-container *ngIf="conhecimentoEdicao.arquivo_nome == null">
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="imagemConhecimento.click()" [disabled]="enviandoArquivo">
                <i class="fa fa-image"></i> Anexar imagem
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="arquivoConhecimento.click()" [disabled]="enviandoArquivo">
                <i class="fa" [ngClass]="enviandoArquivo ? 'fa-spinner fa-spin' : 'fa-paperclip'"></i>
                {{ enviandoArquivo ? 'Enviando...' : 'Anexar arquivo (grade, apresentacao...)' }}
              </button>
              <small class="ia-kb-arquivo-dica">A IA envia o anexo ao contato quando ele pedir (ex.: grade de aulas). Imagens JPG e PNG sao enviadas como imagem no WhatsApp. Max 10 MB.</small>
            </ng-container>

            <span class="ia-kb-arquivo-chip" *ngIf="conhecimentoEdicao.arquivo_nome != null">
              <i class="fa" [ngClass]="conhecimentoTemImagem(conhecimentoEdicao) ? 'fa-image' : 'fa-paperclip'"></i> {{ conhecimentoEdicao.arquivo_nome }}
              <button type="button" class="ia-kb-arquivo-remover" (click)="removerArquivoConhecimento()" title="Remover anexo">
                <i class="fa fa-times"></i>
              </button>
            </span>
          </div>

          <div class="mt-2" *ngIf="conhecimentoEdicao.arquivo_url && conhecimentoTemImagem(conhecimentoEdicao)">
            <img class="ia-kb-imagem-preview" [src]="conhecimentoEdicao.arquivo_url" [alt]="conhecimentoEdicao.arquivo_nome || 'Imagem do conhecimento'" />
            <small class="ia-kb-arquivo-dica d-block">Este anexo sera enviado como imagem no WhatsApp.</small>
          </div>

          <div class="ia-config-grid mt-2">
            <label>
              Link para enviar (opcional)
              <input class="form-control" [(ngModel)]="conhecimentoEdicao.link_url" placeholder="Ex.: https://site.com.br/planos" />
            </label>
            <label>
              Titulo do link (opcional)
              <input class="form-control" [(ngModel)]="conhecimentoEdicao.link_titulo" placeholder="Ex.: Planos e horarios" />
            </label>
          </div>
          <p class="ia-whats-kb-desc" *ngIf="conhecimentoEdicao.link_url">
            A IA pode enviar este link quando fizer sentido para este conhecimento, usando um marcador interno que o sistema substitui na conversa.
          </p>

          <div class="mt-2">
            <button type="button" class="btn btn-sm btn-primary mr-2" (click)="salvarConhecimento()" [disabled]="salvandoConhecimento || enviandoArquivo">{{ salvandoConhecimento ? 'Salvando...' : 'Salvar conhecimento' }}</button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelarConhecimento()" [disabled]="salvandoConhecimento">Cancelar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Fluxo guiado de pedido (modelo COMBUSTIVEIS): somente leitura, nao altera nenhuma configuracao -->

    <div class="ia-whats-section mt-4" *ngIf="configuracao.modelo_ia_empresa == 'COMBUSTIVEIS'">
      <div class="ia-whats-header">
        <h2><i class="fa fa-truck"></i> Fluxo guiado de pedido</h2>
        <p>Este cliente usa o modelo de vendas guiado: a IA conduz o cliente etapa por etapa até fechar o pedido. O passo a passo abaixo é só para consulta.</p>
      </div>

      <div class="ia-fluxo-diagrama">
        <div class="ia-fluxo-passo ia-fluxo-passo-alerta">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-comments-o"></i> Intenção de compra</div>
          <div class="ia-fluxo-passo-desc">Cliente demonstra interesse em comprar</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo ia-fluxo-passo-alerta">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-user-times"></i> Sem vínculo?</div>
          <div class="ia-fluxo-passo-desc">Sem cliente vinculado → transfere para humano</div>
        </div>

        <div class="ia-fluxo-quebra"></div>

        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-cube"></i> Produto</div>
          <div class="ia-fluxo-passo-desc">Lista os produtos ativos para o cliente escolher</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-calendar"></i> Prazo</div>
          <div class="ia-fluxo-passo-desc">Prazos de pagamento do cliente (ou do padrão da empresa)</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-sort-numeric-asc"></i> Quantidade</div>
          <div class="ia-fluxo-passo-desc">Cliente informa a quantidade desejada</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-tag"></i> Preço</div>
          <div class="ia-fluxo-passo-desc">Menor preço disponível para a quantidade pedida. Sem preço → transfere para humano</div>
        </div>

        <div class="ia-fluxo-quebra"></div>

        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-map-marker"></i> Local de entrega</div>
          <div class="ia-fluxo-passo-desc">Só pergunta se o cliente tiver locais cadastrados</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-check-circle"></i> Confirmação</div>
          <div class="ia-fluxo-passo-desc">Resumo do pedido com o total, aguardando "sim" do cliente</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo ia-fluxo-passo-sucesso">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-file-text-o"></i> Pedido criado</div>
          <div class="ia-fluxo-passo-desc">Pedido gravado como rascunho no sistema</div>
        </div>
        <div class="ia-fluxo-seta">→</div>
        <div class="ia-fluxo-passo ia-fluxo-passo-sucesso">
          <div class="ia-fluxo-passo-titulo"><i class="fa fa-paper-plane"></i> Pedido enviado</div>
          <div class="ia-fluxo-passo-desc">Cliente confirma e o pedido é enviado automaticamente</div>
        </div>
      </div>

      <p class="ia-whats-kb-desc mt-2">Qualquer falha em alguma etapa (dados incompletos, sem preço, sem produto cadastrado) transfere a conversa para um atendente humano automaticamente.</p>
    </div>

    <!-- Planos & Pagamento no Chat -->

    <div class="ia-whats-section mt-4" *ngIf="configuracao.modelo_ia_empresa != 'COMBUSTIVEIS'">
      <div class="ia-whats-header">
        <h2><i class="fa fa-credit-card"></i> Planos &amp; Pagamento no Chat</h2>
        <p>A IA apresenta estes planos direto na conversa. Escolha como o cliente finaliza a compra.</p>
      </div>

      <div class="ia-config-grid">
        <label>
          Forma de pagamento
          <select class="form-control" [(ngModel)]="configuracao.whatsapp_pagamento_tipo">
            <option value="MERCADOPAGO">Mercado Pago (checkout automatico, pix/cartao/parcelas)</option>
            <option value="LINK_DIRETO">Link direto para o site (cadastrado por plano)</option>
            <option value="DESATIVADO">Nao usar planos no chat (desativado)</option>
          </select>
        </label>
      </div>
      <p class="ia-whats-kb-desc" *ngIf="configuracao.whatsapp_pagamento_tipo == 'MERCADOPAGO'">
        A IA gera o link de pagamento no Mercado Pago direto na conversa. O checkout decide pix, cartao e parcelas, e a confirmacao chega automaticamente.
      </p>
      <p class="ia-whats-kb-desc" *ngIf="configuracao.whatsapp_pagamento_tipo == 'LINK_DIRETO'">
        A IA envia o link cadastrado em cada plano abaixo para o cliente finalizar a compra no seu proprio site. Nao ha confirmacao automatica de pagamento neste modo.
      </p>
      <p class="ia-whats-kb-desc" *ngIf="configuracao.whatsapp_pagamento_tipo == 'DESATIVADO'">
        A IA nunca oferece planos nem links de pagamento nesta conversa. Se o contato perguntar preco ou demonstrar interesse em comprar, a IA transfere para um atendente humano automaticamente.
      </p>

      <!-- Credenciais Mercado Pago (write-only: nunca exibidas apos salvas) -->
      <div class="ia-whats-kb mt-2" *ngIf="configuracao.whatsapp_pagamento_tipo == 'MERCADOPAGO'">
        <div class="ia-whats-kb-header">
          <h3>Credenciais do Mercado Pago</h3>
        </div>

        <div class="ia-mp-instrucoes">
          <b>Como gerar o Public Key e o Access Token:</b>
          <ol>
            <li>Acesse sua conta do Mercado Pago</li>
            <li>Menu &rarr; Configurações &rarr; Negócio &rarr; Integrações &rarr; Suas Integrações</li>
            <li>Abra sua integração e vá em <b>Credenciais de Produção</b></li>
            <li>Copie o <b>Public Key</b> e o <b>Access Token</b> e cole nos campos abaixo</li>
          </ol>
        </div>

        <div class="ia-config-grid">
          <label>
            Public Key
            <input class="form-control" type="password" autocomplete="new-password" [(ngModel)]="mercadoPagoPublicToken" placeholder="Deixe vazio para manter o valor atual" />
          </label>
          <label>
            Access Token
            <input class="form-control" type="password" autocomplete="new-password" [(ngModel)]="mercadoPagoAccessToken" placeholder="Deixe vazio para manter o valor atual" />
          </label>
        </div>

        <p class="ia-whats-kb-desc">Por segurança, os valores salvos nunca sao exibidos aqui novamente. Preencha somente para cadastrar ou trocar as credenciais.</p>

        <button type="button" class="btn btn-sm btn-primary" (click)="salvarMercadoPagoTokens()" [disabled]="salvandoMercadoPago">
          {{ salvandoMercadoPago ? 'Salvando...' : 'Salvar credenciais do Mercado Pago' }}
        </button>
      </div>

      <div class="ia-whats-kb-vazio mt-2" *ngIf="configuracao.whatsapp_pagamento_tipo == 'DESATIVADO'">
        Venda/checkout automatico desativado para este cliente. Nenhum plano e gerenciado nem oferecido pela IA.
      </div>

      <ng-container *ngIf="configuracao.whatsapp_pagamento_tipo != 'DESATIVADO'">
      <div class="ia-whats-kb-header mt-2">
        <span></span>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="novoPlano()" [disabled]="planoEdicao != null">Adicionar plano</button>
      </div>

      <div class="table-responsive" *ngIf="planos.length > 0">
        <table class="table table-sm ia-planos-tabela">
          <thead>
            <tr>
              <th>Plano</th>
              <th>Escopo</th>
              <th class="text-right">Valor</th>
              <th>Condicao</th>
              <th *ngIf="configuracao.whatsapp_pagamento_tipo == 'LINK_DIRETO'">Link de pagamento</th>
              <th class="text-center">Destaque</th>
              <th class="text-center">Ativo</th>
              <th class="text-right">Acoes</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plano of planos" [class.ia-plano-inativo]="!plano.ativo">
              <td>
                <b>{{ plano.nome }}</b>
                <small class="d-block text-muted" *ngIf="plano.descricao">{{ plano.descricao }}</small>
              </td>
              <td><span class="badge badge-pill ia-escopo-badge" [ngClass]="plano.seller_id ? 'ia-escopo-unidade' : 'ia-escopo-geral'">{{ getEscopoNome(plano) }}</span></td>
              <td class="text-right">{{ plano.valor | currency:'BRL' }}</td>
              <td>{{ plano.condicao || '—' }}</td>
              <td *ngIf="configuracao.whatsapp_pagamento_tipo == 'LINK_DIRETO'">
                <small class="ia-plano-link" *ngIf="plano.link_pagamento" [title]="plano.link_pagamento">{{ plano.link_pagamento }}</small>
                <span class="text-danger" *ngIf="!plano.link_pagamento"><i class="fa fa-exclamation-triangle"></i> Sem link</span>
              </td>
              <td class="text-center">
                <span class="badge badge-pill ia-plano-badge-destaque" *ngIf="plano.destaque">Mais popular</span>
              </td>
              <td class="text-center">
                <span class="ia-toggle" [class.ia-toggle-on]="plano.ativo" (click)="alternarAtivoPlano(plano)" title="Ativar/Desativar plano"></span>
              </td>
              <td class="text-right">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="editarPlano(plano)" [disabled]="planoEdicao != null">Editar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ia-whats-kb-vazio" *ngIf="planos.length == 0 && planoEdicao == null">
        Nenhum plano cadastrado. Enquanto nao houver planos ativos, a IA nao oferece pagamento no chat.
      </div>

      <div class="ia-whats-kb-editor" *ngIf="planoEdicao != null">
        <div class="ia-config-grid">
          <label>
            Nome
            <input class="form-control" [(ngModel)]="planoEdicao.nome" placeholder="Ex.: Trimestral" />
          </label>
          <label>
            Valor (R$)
            <input class="form-control" type="number" min="0" step="0.01" [(ngModel)]="planoEdicao.valor" />
          </label>
          <label>
            Condicao
            <input class="form-control" [(ngModel)]="planoEdicao.condicao" placeholder="Ex.: A vista ou em 3x" />
          </label>
          <label>
            Aplicar para
            <select class="form-control" [(ngModel)]="planoEdicao.seller_id">
              <option [ngValue]="null">Todas as unidades</option>
              <option *ngFor="let vendedor of vendedores" [ngValue]="vendedor.id">{{ vendedor.fullname }}</option>
            </select>
          </label>
          <label>
            Destaque
            <select class="form-control" [(ngModel)]="planoEdicao.destaque">
              <option [ngValue]="true">Mais popular</option>
              <option [ngValue]="false">Sem destaque</option>
            </select>
          </label>
        </div>
        <label class="w-100 mt-2">
          Descricao
          <input class="form-control" [(ngModel)]="planoEdicao.descricao" placeholder="Ex.: Acesso livre a musculacao e aulas coletivas" />
        </label>
        <label class="w-100 mt-2" *ngIf="configuracao.whatsapp_pagamento_tipo == 'LINK_DIRETO'">
          Link de pagamento (site externo)
          <input class="form-control" [(ngModel)]="planoEdicao.link_pagamento" placeholder="Ex.: https://meusite.com.br/checkout/plano-trimestral" />
        </label>
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-primary mr-2" (click)="salvarPlano()" [disabled]="salvandoPlano">{{ salvandoPlano ? 'Salvando...' : 'Salvar plano' }}</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelarPlano()" [disabled]="salvandoPlano">Cancelar</button>
        </div>
      </div>
      </ng-container>
    </div>

    <!-- Lacunas de conhecimento -->

    <div class="ia-whats-section mt-4">
      <div class="ia-whats-header">
        <h2><i class="fa fa-exclamation-triangle"></i> Lacunas de conhecimento</h2>
        <p>Perguntas que a IA nao soube responder nos ultimos 7 dias — 1 clique para adicionar a base.</p>
      </div>

      <div class="ia-whats-kb-item" *ngFor="let lacuna of lacunas">
        <div class="ia-whats-kb-item-text">
          <b><i class="fa fa-question-circle-o ia-lacuna-icone"></i> "{{ lacuna.pergunta }}"</b>
          <small>Perguntado {{ lacuna.total }}x · ultima vez {{ lacuna.ultima_data | date:'dd/MM HH:mm' }}</small>
        </div>
        <div class="ia-whats-kb-item-actions">
          <button type="button" class="btn btn-sm ia-lacuna-btn" (click)="ensinarLacuna(lacuna)" [disabled]="conhecimentoEdicao != null">
            <i class="fa fa-magic"></i> Responder e ensinar
          </button>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="descartarLacuna(lacuna)" title="Ja coberta por um conhecimento existente">
            <i class="fa fa-trash-o"></i> Descartar
          </button>
        </div>
      </div>

      <div class="ia-whats-kb-vazio" *ngIf="lacunas.length == 0">
        Nenhuma lacuna registrada nos ultimos 7 dias. Quando a IA nao souber responder algo, a pergunta aparece aqui.
      </div>
    </div>

    <!-- Ajuste de Respostas (aprendizado continuo) -->

    <div class="ia-whats-section mt-4">
      <div class="ia-whats-header">
        <h2>Ajuste de Respostas (aprendizado continuo)</h2>
        <p>Toda resposta editada ou recusada no atendimento vira aprendizado: as ultimas correcoes sao aplicadas automaticamente ao comportamento da IA. Janela de {{ aprendizado.dias_janela }} dias.</p>
      </div>

      <div class="ia-metricas">
        <div class="ia-metrica" [class.ia-metrica-destaque]="aprendizado.taxa_aprovacao_sem_edicao >= 90">
          <div class="ia-metrica-valor">{{ aprendizado.taxa_aprovacao_sem_edicao | number:'1.0-1' }}%</div>
          <div class="ia-metrica-rotulo">Aprovadas sem edicao</div>
        </div>
        <div class="ia-metrica">
          <div class="ia-metrica-valor">{{ aprendizado.total_aprovadas_sem_edicao + aprendizado.total_editadas }}</div>
          <div class="ia-metrica-rotulo">Sugestoes avaliadas</div>
        </div>
        <div class="ia-metrica">
          <div class="ia-metrica-valor">{{ aprendizado.total_editadas }}</div>
          <div class="ia-metrica-rotulo">Editadas</div>
        </div>
        <div class="ia-metrica">
          <div class="ia-metrica-valor">{{ aprendizado.total_recusadas }}</div>
          <div class="ia-metrica-rotulo">Recusadas</div>
        </div>
        <div class="ia-metrica">
          <div class="ia-metrica-valor">{{ aprendizado.total_enviadas_auto }}</div>
          <div class="ia-metrica-rotulo">Enviadas no automatico</div>
        </div>
        <div class="ia-metrica">
          <div class="ia-metrica-valor">{{ aprendizado.total_handoff }}</div>
          <div class="ia-metrica-rotulo">Transferidas p/ humano</div>
        </div>
      </div>

      <div class="ia-aprendiz-banner" *ngIf="aprendizado.sugerir_modo_auto">
        <div>
          <b><i class="fa fa-graduation-cap"></i> A IA esta pronta para o modo Automatico!</b>
          <small>Taxa de aprovacao sem edicao de {{ aprendizado.taxa_aprovacao_sem_edicao | number:'1.0-1' }}% nos ultimos {{ aprendizado.dias_janela }} dias. Voce pode migrar do modo Aprovacao para o Automatico com seguranca.</small>
        </div>
        <button type="button" class="btn btn-sm ia-aprendiz-btn" (click)="aplicarModoAutomatico()" [disabled]="salvando">
          <i class="fa fa-bolt"></i> Ativar modo Automatico
        </button>
      </div>

      <div class="ia-correcoes" *ngIf="aprendizado.correcoes.length > 0">
        <div class="ia-correcao" *ngFor="let correcao of aprendizado.correcoes">
          <i class="fa ia-correcao-icone" [ngClass]="correcao.status == 'EDITADO' ? 'fa-lightbulb-o' : 'fa-times-circle-o'"></i>
          <div class="ia-correcao-texto">
            <div class="ia-correcao-pergunta" *ngIf="correcao.pergunta">Pergunta: "{{ correcao.pergunta }}"</div>
            <div class="ia-correcao-original">"{{ correcao.resposta_original }}"</div>
            <div class="ia-correcao-final" *ngIf="correcao.resposta_final">"{{ correcao.resposta_final }}"</div>
            <div class="ia-correcao-meta">
              {{ correcao.status == 'EDITADO' ? 'Corrigido' : 'Recusado' }} por {{ correcao.usuario_acao || 'atendente' }} · {{ correcao.data_acao | date:'dd/MM HH:mm' }}
              <span class="ia-correcao-aplicada" *ngIf="correcao.status == 'EDITADO'"> · aplicado a IA ✓</span>
            </div>
          </div>
        </div>
      </div>

      <div class="ia-whats-kb-vazio" *ngIf="aprendizado.correcoes.length == 0">
        Nenhuma correcao registrada ainda. Ao editar ou recusar sugestoes no atendimento, elas aparecem aqui e passam a orientar a IA.
      </div>
    </div>

    <!-- Etapas do Kanban -->

    <div class="ia-whats-section mt-4">
      <div class="ia-whats-header">
        <h2>Etapas do Kanban</h2>
        <p>Gerencie as etapas intermediarias do fluxo comercial do WhatsApp.</p>
      </div>

      <div class="ia-whats-kb">
        <div class="alert alert-secondary">
          As etapas
          <strong>Aberto</strong>,
          <strong>Atendimento</strong>,
          <strong>Ganho</strong>
          e
          <strong>Perda</strong>
          sao fixas. Aqui voce gerencia apenas as etapas intermediarias do fluxo comercial.
        </div>

        <div class="row align-items-end mb-4">
          <div class="col-md-3 mb-2">
            <label class="mb-1">Nova etapa</label>
            <input class="form-control form-control-sm" [(ngModel)]="novaEtapa.nome" maxlength="120" />
          </div>
          <div class="col-md-2 mb-2">
            <label class="mb-1">Tipo</label>
            <select class="form-control form-control-sm" [(ngModel)]="novaEtapa.tipo">
              <option *ngFor="let tipo of tiposEtapaWhatsApp" [value]="tipo">{{ tipo }}</option>
            </select>
          </div>
          <div class="col-md-3 mb-2">
            <label class="mb-1">Cor</label>
            <input class="form-control form-control-sm" [(ngModel)]="novaEtapa.cor_hex" maxlength="7" />
          </div>
          <div class="col-md-2 mb-2">
            <div class="custom-control custom-switch mt-4">
              <input class="custom-control-input" type="checkbox" id="flagNovaEtapaAtivaIa" [(ngModel)]="novaEtapa.is_active" />
              <label class="custom-control-label" for="flagNovaEtapaAtivaIa">Ativa</label>
            </div>
          </div>
          <div class="col-md-2 mb-2">
            <button class="btn btn_formulario btn-sm w-100" type="button" (click)="adicionarEtapa()">
              Adicionar
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-sm table-hover ia-kanban-etapas-tabela">
            <thead>
              <tr>
                <th>Ordem</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Cor</th>
                <th>Status</th>
                <th class="text-right">Acoes</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let etapa of etapas">
                <td>{{ etapa.ordem }}</td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    [(ngModel)]="etapa.nome" />
                </td>
                <td>
                  <select class="form-control form-control-sm" [(ngModel)]="etapa.tipo" [disabled]="etapa.is_system">
                    <option *ngFor="let tipo of tiposEtapaWhatsApp" [value]="tipo">{{ tipo }}</option>
                  </select>
                </td>
                <td>
                  <input
                    class="form-control form-control-sm"
                    [(ngModel)]="etapa.cor_hex"
                    [disabled]="etapa.is_system" />
                </td>
                <td>{{ etapa.is_active ? 'Ativa' : 'Inativa' }}</td>
                <td class="text-right">
                  <button class="btn btn-outline-secondary btn-sm mr-1" type="button" (click)="moverEtapa(etapa, -1)" [disabled]="etapa.is_system">
                    <i class="fa fa-arrow-up"></i>
                  </button>
                  <button class="btn btn-outline-secondary btn-sm mr-1" type="button" (click)="moverEtapa(etapa, 1)" [disabled]="etapa.is_system">
                    <i class="fa fa-arrow-down"></i>
                  </button>
                  <button class="btn btn-outline-primary btn-sm mr-1" type="button" (click)="salvarEtapa(etapa)">
                    Salvar
                  </button>
                  <button class="btn btn-outline-danger btn-sm" type="button" (click)="excluirEtapa(etapa)" [disabled]="etapa.permite_exclusao == false">
                    Excluir
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="ia-config-actions">
      <button type="button" class="btn btn-primary" (click)="salvar()" [disabled]="salvando">Salvar configuracao</button>
    </div>
  </div>
</div>

<ng-template #semPermissao>
  <div class="ia-config-page">
    <div class="ia-config-card text-center">
      <h2>Acesso restrito</h2>
      <p>Somente usuarios Master ou Diretoria podem configurar a IA.</p>
    </div>
  </div>
</ng-template>
